import { render } from "./MdTextfieldTag.vue?vue&type=template&id=6e209d00&ts=true"
import script from "./MdTextfieldTag.vue?vue&type=script&lang=ts"
export * from "./MdTextfieldTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__